import { Box } from '@zoopla-eng/zds-components/box';
import { Checkbox } from '@zoopla-eng/zds-components/checkbox';
import { getPropertyType } from '@zoopla/listing-search/get-property-type';
import { checkboxWrapperStyle } from './PropertyType.styles.css';

const propertyTypes = ['property', 'houses', 'flats', 'farms_land'] as const;

const propertySubTypes = [
    'detached',
    'semi_detached',
    'terraced',
    'flats',
    'bungalow',
    'farms_land',
    'park_home'
] as const;

const propertySubTypeLabels = {
    detached: 'Detached',
    semi_detached: 'Semi-detached',
    terraced: 'Terraced',
    flats: 'Flats',
    bungalow: 'Bungalows',
    farms_land: 'Farms/land',
    park_home: 'Park homes'
};

export type PropertyType = (typeof propertyTypes)[number];
export type PropertySubType = Array<(typeof propertySubTypes)[number]>;

type PropertyTypeProps = {
    value: { propertyType: PropertyType; propertySubType: PropertySubType };
    onChange: ({
        propertySubType,
        propertyType
    }: {
        propertySubType: PropertySubType;
        propertyType: PropertyType;
    }) => void;
};

export const PropertyType: React.FC<PropertyTypeProps> = ({
    value,
    onChange
}) => {
    return (
        <Box display="flex" flexDirection="row" flexWrap="wrap" rowGap="S400">
            {[
                <div key="show_all" className={checkboxWrapperStyle}>
                    <Checkbox
                        name="show-all"
                        label="Show all"
                        checked={value.propertySubType.length === 0}
                        onCheckedChange={() => {
                            onChange({
                                propertySubType: [],
                                propertyType: 'property'
                            });
                        }}
                    />
                </div>,
                ...propertySubTypes.map((propertySubType) => {
                    return (
                        <div
                            key={propertySubType}
                            className={checkboxWrapperStyle}
                        >
                            <Checkbox
                                name={propertySubTypeLabels[propertySubType]}
                                label={propertySubTypeLabels[propertySubType]}
                                checked={value.propertySubType.includes(
                                    propertySubType
                                )}
                                onCheckedChange={(checked) => {
                                    if (checked) {
                                        const _propertySubType = [
                                            ...value.propertySubType,
                                            propertySubType
                                        ];

                                        onChange({
                                            propertySubType: _propertySubType,
                                            propertyType:
                                                getPropertyType(
                                                    _propertySubType
                                                )
                                        });
                                    } else {
                                        const _propertySubType =
                                            value.propertySubType.filter(
                                                (i) => i !== propertySubType
                                            );

                                        onChange({
                                            propertySubType: _propertySubType,
                                            propertyType:
                                                getPropertyType(
                                                    _propertySubType
                                                )
                                        });
                                    }
                                }}
                            />
                        </div>
                    );
                })
            ]}
        </Box>
    );
};
